import { START_LOCATION, type NavigationGuard } from 'vue-router';

// eslint-disable-next-line func-style
export const clearProductListViewDataHistoryStateOnRefresh: NavigationGuard = (to, from) => {
    if (from === START_LOCATION) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { productListViewData, ...historyState } = window.history.state ?? {};
        window.history.replaceState(historyState, '');
    }

    return true;
};
